export const ERROR_UNEXPECTED = 'Algo inesperado ocorreu, tente novamente mais tarde.'
